// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"65343867","309":"f9411bf1","676":"331c70a8","876":"e9aa3cb7"}[chunkId] + ".chunk.js";
};